// extracted by mini-css-extract-plugin
module.exports = {"container":"EmojiGestureSelection_container__LSjSE","closeButton":"EmojiGestureSelection_closeButton__1s4bJ","emojiButton":"EmojiGestureSelection_emojiButton__2_wC0"};